export default {
  polish: "POLISH_TYPE_POLISH",
  nano: "POLISH_TYPE_NANO",
  wax: "POLISH_TYPE_WAX"
};
